import { tokenStorage } from '@/shared/storage-service';
import axios from './axios-defaults';

import appConfig from '../app.config';
// import { tokenMutations } from './auth-session-store';

import requestInterceptor from './auth-request-interceptor';
import HttpEventPublisher from './http-event-publisher';

const httpClient = axios.create({
  baseURL: appConfig.authApiRootUrl,
});

httpClient.interceptors.request.use(requestInterceptor);

httpClient.interceptors.response.use(
  (response) => {
    HttpEventPublisher.publishResponse();
    return response;
  },
  (error) => {
    HttpEventPublisher.publishResponse();
    const { config } = error;
    const originalRequest = config;
    // console.log('HTTP AUTH Client: ', error);
    let err;
    if (error.isAxiosError && error.code === 'ECONNABORTED') {
      err = { status: 418, error }; // internal network error
      // timeout on sign out - clean up storage
      if (originalRequest.method === 'delete' && originalRequest.url === '/token') {
        tokenStorage.clearTokens(); // added to keep persisted tokens insync
      }
    } else {
      const { status } = error.response;
      err = { status, error };
      // unauthorized on refresh token
      if (status === 401 && originalRequest.method === 'post' && originalRequest.url === '/token') {
        tokenStorage.clearTokens(); // added to keep persisted tokens insync
      }
    }

    return Promise.reject(err);
  },
);

export default httpClient;
